/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/vpnMappers";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a Vpn. */
export class Vpn {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a Vpn.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Deprecated endpoint due to VPN feature deprication. Return false for backcompat.
   * @summary Retrieves consumer VPN status for the current user.
   * @param [options] The optional parameters
   * @returns Promise<Models.VpnGetConsumerVpnStatusResponse>
   */
  getConsumerVpnStatus(options?: coreHttp.RequestOptionsBase): Promise<Models.VpnGetConsumerVpnStatusResponse>;
  /**
   * @param callback The callback
   */
  getConsumerVpnStatus(callback: coreHttp.ServiceCallback<Models.ConsumerVpnResponse>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getConsumerVpnStatus(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.ConsumerVpnResponse>): void;
  getConsumerVpnStatus(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.ConsumerVpnResponse>, callback?: coreHttp.ServiceCallback<Models.ConsumerVpnResponse>): Promise<Models.VpnGetConsumerVpnStatusResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getConsumerVpnStatusOperationSpec,
      callback) as Promise<Models.VpnGetConsumerVpnStatusResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getConsumerVpnStatusOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/Vpn/status",
  responses: {
    200: {
      bodyMapper: Mappers.ConsumerVpnResponse
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
